import { Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogComponent } from '../../../../../@core/components/ui/dialog/dialog.component';
import { ShareToUsersComponent } from '../../../../../@shared/components/share-to-users/share-to-users.component';
import { IContract } from '../../../../models/contract-management.model';
import { ShareContractService } from '../../../../services/share-contract.service';
import { IShareContract, IShareUser, SHARE_ACCESS, SHARE_FEATURE } from '../../../../../@core/models/model';
import { ToastService } from '../../../../../@core/services/toast.service';
import { ButtonComponent } from '../../../../../@core/components/ui/button/button.component';
import { SVG } from 'src/app/common/svgs';
import { GeotechnicalAnalysisReport } from 'src/app/features/geotechnical-analysis/services/geotechnical-analysis.service';


@Component({
  selector: 'app-share-doc',
  imports: [
    ButtonModule,
    DialogComponent,
    ShareToUsersComponent,
    ButtonComponent,
  ],
  standalone: true,
  templateUrl: './share-doc.component.html',
  styleUrl: './share-doc.component.scss'
})
export class ShareDocComponent {

  @Input() contract!: IContract
  @Input() workspace!: string | null
  @Input() projectId!: string
  @Input() feature: SHARE_FEATURE = SHARE_FEATURE.CONTRACT

  SVG = SVG;
  SHARE_FEATURE = SHARE_FEATURE;

  shareDialog: boolean = false
  shareDetails: { users: IShareUser[], anyone: SHARE_ACCESS, workspaceShare?: boolean, projectShare?: boolean } = { users: [], anyone: SHARE_ACCESS.RESTRICTED, workspaceShare: false, projectShare: false };

  isSharedWithWorkspace: boolean = false
  isSharedWithProject: boolean = false

  constructor(
    private shareService: ShareContractService,
    private toastService: ToastService
  ) {
  }

  ngOnInit() {
    this.getShareDetails()
  }

  getShareDetails() {
    this.shareService.getShareDetails(this.contract._id, this.feature).subscribe(res => {
      if (res.success) {
        this.shareDetails = res.data
        this.shareDetails.workspaceShare = res.data.workspaceShare ? true : false
        this.shareDetails.projectShare = res.data.projectShare ? true : false
        this.isSharedWithWorkspace = this.shareDetails.workspaceShare
        this.isSharedWithProject = this.shareDetails.projectShare
      }
    })
  }

  openShareDialog() {
    this.getShareDetails()
    this.shareDialog = true
  }

  onCloseShareDialog() {
    this.shareDialog = false
  }

  toggleShareDialog() {
    this.shareDialog = !this.shareDialog
  }

  addUserToShare(shareUser: Partial<IShareUser>) {
    this.shareService.addUserToShare(this.contract._id, shareUser, this.feature).subscribe(res => {
      if (res.success) {
        this.shareDetails = res.data
        this.shareDetails.workspaceShare = res.data.workspaceShare ? true : false
        this.shareDetails.projectShare = res.data.projectShare ? true : false
        this.isSharedWithWorkspace = this.shareDetails.workspaceShare
        this.isSharedWithProject = this.shareDetails.projectShare
        this.toastService.success('Member added successfully')
      }
    })
  }

  removeUserFromShare(shareUser: Partial<IShareUser>) {
    this.shareService.removeUserFromShare(this.contract._id, shareUser._id as string, this.feature).subscribe(res => {
      if (res.success) {
        this.toastService.success('Member removed successfully')
        // Refetch share details to get updated state from backend
        this.getShareDetails()
      }
    })
  }

  refreshShareDetails() {
    this.getShareDetails()
  }

  updateSharedUser(shareUser: IShareUser) {
    this.shareService.updateShareUser(this.contract._id, shareUser, this.feature).subscribe(res => {
      if (res.success) {
        this.toastService.success('Member updated successfully')
      }
    })
  }

  changeAnyoneAccess(access: SHARE_ACCESS) {
    this.shareService.updateAnyoneAccess(this.contract._id, access).subscribe(res => {
      if (res.success) {
        this.toastService.success('Access updated successfully')
      }
    })
  }

  changeSharedWithWorkspace(value: boolean) {
    if (!this.workspace) return
    let workspaceShare = value ? this.workspace : null
    this.shareService.updateShare(this.contract._id, { workspaceShare: workspaceShare }, this.feature).subscribe(res => {
      if (res.success) {
        this.toastService.success('Access updated successfully')
      }
    })
  }

  changeSharedWithProject(value: boolean) {
    let projectShare = value ? this.projectId : null
    this.shareService.updateShare(this.contract._id, { projectShare: projectShare }, this.feature).subscribe(res => {
      if (res.success) {
        this.toastService.success('Access updated successfully')
      }
    })
  }
}










